import { cn } from '../../lib/utils';

function Skeleton({ className, ...props }) {
    return (
        <div
            data-slot="skeleton"
            className={cn('tw-animate-pulse tw-rounded-md tw-bg-accent', className)}
            {...props}
        />
    );
}

export { Skeleton };
